import { render } from "./SettingsHome.vue?vue&type=template&id=303b3d9c&scoped=true"
import script from "./SettingsHome.vue?vue&type=script&lang=js"
export * from "./SettingsHome.vue?vue&type=script&lang=js"

import "./SettingsHome.vue?vue&type=style&index=0&id=303b3d9c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303b3d9c"]])

export default __exports__